import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ActionModel } from '../_models/action.model';
import { QueryParamsModel } from '../../_base/crud';

export enum ActionActionTypes {
  AllActionsRequested = '[Actions] All Actions Requested',
  AllActionsLoaded = '[Actions] All Actions Loaded',
  ActionOnServerCreated = '[Actions] Action On Server Created',
  ActionCreated = '[Actions] Action Created',
  ActionOnServerUpdated = '[Actions] Action On Server Updated',
  ActionUpdated = '[Actions] Action Updated',
  ActionOnServerDeleted = '[Actions] Action On Server Deleted',
  ActionDeleted = '[Actions] Action Deleted',
  ActionsPageRequested = '[Actions] Actions Page Requested',
  ActionsPageLoaded = '[Actions] Actions Page Loaded',
  ActionsPageCancelled = '[Actions] Actions Page Cancelled',
  ActionsPageToggleLoading = '[Actions] Actions Page Toggle Loading',
  ActionsActionToggleLoading = '[Actions] Actions Action Toggle Loading',
  ThrowActionError = '[Actions] Throw Error',
  FireActionSuccess = '[Actions] Fire Success',
  ClearActionState = '[Actions] Clear Action Insurance State',
}

export class ActionOnServerCreated implements Action {
  readonly type = ActionActionTypes.ActionOnServerCreated;
  constructor(public payload: { action: ActionModel }) {}
}

export class ActionCreated implements Action {
  readonly type = ActionActionTypes.ActionCreated;
  constructor(public payload: { action: ActionModel }) {}
}

export class ThrowActionError implements Action {
  readonly type = ActionActionTypes.ThrowActionError;
  constructor(public payload: { error: any }) {}
}

export class FireActionSuccess implements Action {
  readonly type = ActionActionTypes.FireActionSuccess;
  constructor(public payload: { action_type: string }) {}
}

export class ActionOnServerUpdated implements Action {
  readonly type = ActionActionTypes.ActionOnServerUpdated;
  constructor(
    public payload: {
      partialAction: Update<ActionModel>;
      action: ActionModel;
    },
  ) {}
}
export class ActionUpdated implements Action {
  readonly type = ActionActionTypes.ActionUpdated;
  constructor(
    public payload: {
      partialAction: Update<ActionModel>;
      action: ActionModel;
    },
  ) {}
}

export class ActionOnServerDeleted implements Action {
  readonly type = ActionActionTypes.ActionOnServerDeleted;
  constructor(public payload: { id: number }) {}
}

export class ActionDeleted implements Action {
  readonly type = ActionActionTypes.ActionDeleted;
  constructor(public payload: { id: number }) {}
}

export class ActionsPageRequested implements Action {
  readonly type = ActionActionTypes.ActionsPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class ActionsPageLoaded implements Action {
  readonly type = ActionActionTypes.ActionsPageLoaded;
  constructor(
    public payload: { actions: ActionModel[]; totalCount: number; page: QueryParamsModel },
  ) {}
}

export class ActionsPageCancelled implements Action {
  readonly type = ActionActionTypes.ActionsPageCancelled;
}

export class ActionsPageToggleLoading implements Action {
  readonly type = ActionActionTypes.ActionsPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ActionsActionToggleLoading implements Action {
  readonly type = ActionActionTypes.ActionsActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ClearActionState implements Action {
  readonly type = ActionActionTypes.ClearActionState;
}

export type ActionActions =
  | ActionCreated
  | ActionUpdated
  | ActionDeleted
  | ActionOnServerCreated
  | ActionOnServerUpdated
  | ActionOnServerDeleted
  | ActionsPageLoaded
  | ActionsPageCancelled
  | ActionsPageToggleLoading
  | ActionsPageRequested
  | ThrowActionError
  | FireActionSuccess
  | ActionsActionToggleLoading
  | ClearActionState;
